/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_Pop_OnInputs */



/**
* | output |
* | --- |
* | "Pop-On" |
*
* @param {Caption_Style_Pop_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_pop_on = /** @type {((inputs?: Caption_Style_Pop_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_Pop_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pop-On")
	if (locale === "de") return /** @type {LocalizedString} */ ("Pop-On")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pop-On")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Pop-On")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pop-On")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("弹出式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ポップオン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पर पॉप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pop-On")
	return /** @type {LocalizedString} */ ("Pop-On")
});